import React from "react";

const FooterHechoPor = () => {
  return (
    <div className="container-hechopor">
      <p>
        Hecho por <a href="https://pablokoppcv.vercel.app/">Pablo Kopp 👨‍💻 </a>
      </p>
    </div>
  );
};

export default FooterHechoPor;
